import React from 'react'
import { WalletConnection } from "../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { useAddress, useMetamask } from "@thirdweb-dev/react";
import { Link, useNavigate } from "react-router-dom";
// import { ethers } from "ethers";

function SignIn() {
    const connectWithMetamask = useMetamask();
    const address = useAddress();

    const [walletConnectionMutation] = useMutation(WalletConnection);

    const navigate = useNavigate();

    const onSubmit = async (data) => {
      connectWithMetamask();
      let result = await walletConnectionMutation({
        variables: {
          walletAddress: address,
        },
      });
      console.log(result);
      if (result.res) {
        navigate("/profilecreate");
      }
    };

  return (
    <div className='h-screen background'>
        <div className='absolute bottom-52 flex flex-col items-center'>
            <h3 className='text-2xl font-bold'>Ahoy!</h3>
            <p className='px-10 text-center text-xs mt-8'>Lorem ipsum dolor sit amet consectetur. Ut cursus adipiscing dolor velit. Viverra tristique et et nunc nulla pharetra vel arcu ut.</p>
        
        </div>
        <div className='absolute bottom-16 flex flex-col items-center w-full'>
            <button onClick={onSubmit} className='px-5 py-3 bg-black font-semibold text-white rounded-3xl'>Connect Wallet</button>
            <p className='text-xs mt-3'>{address ? address : "Sign up with email"}</p>
            {address && <Link to='/signmail' className='px-3 py-2 mt-3 bg-black rounded-lg text-white'>Next</Link> }
        </div>
    </div>
  )
}

export default SignIn